module.exports = __webpack_public_path__ + "static/img/712-2.7365c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/712/712-2.jpg
// module id = i/qc
// module chunks = 0